import Swiper from 'swiper/bundle'

function instagramSlider() {
  const slider = document.querySelector('[data-target="instagram-slider"]')
  if (slider) {
    const swiper = new Swiper(slider, {
      slidesPerView: 4,
      spaceBetween: 40,
      pagination: {
        el: '.swiper-pagination-events',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.swiper-button-next-events',
        prevEl: '.swiper-button-prev-events',
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
    })
  }
}

export default instagramSlider
